import * as THREE from 'three'
import { MutableRefObject } from "react";
import { DatePicker } from "../UI/DatePicker/DatePicker"
import { WeaveButton } from "../UI/WeaveButton/WeaveButton";
import { WeaveInput } from "../UI/WeaveInput/WeaveInput"
import { addTextureToTerrain } from "@/utils/sceneGeneration";
import styles from './styles.module.scss'

interface SettingsProps {
	currentDate: Date;
	setCurrentDate: (date: Date) => void;
	currentTime: string;
	setCurrentTime: (time: string) => void;
	latitude: number | null;
	setLatitude: (lat: number | null) => void;
	longitude: number | null;
	setLongitude: (lon: number | null) => void;
	sceneRef: MutableRefObject<THREE.Scene | null>;
	rendererRef: MutableRefObject<THREE.WebGLRenderer | null>;
}

export const Settings = (props: SettingsProps) => {
	const {
		currentDate,
		setCurrentDate,
		currentTime,
		setCurrentTime,
		latitude,
		longitude,
		sceneRef,
		rendererRef,
	} = props;

	const loadSateliteView = () => {
		if (!sceneRef.current || !rendererRef.current) return;
		addTextureToTerrain(sceneRef.current, rendererRef.current);
	};

	return (
		<div className={styles.settingsContainer}>
			<div className={`${styles.dateTimeContainer} ${styles.gap10}`}>
				<div className={styles.dateTimeContainer}>
					<label>
						Date:
					</label>
					<DatePicker date={currentDate} onDateChange={setCurrentDate} />
				</div>
				<div className={styles.dateTimeContainer}>
					<label>
						Time:
						<input
							type="time"
							value={currentTime}
							onChange={(e) => setCurrentTime(e.target.value)}
							style={{ marginLeft: '5px' }}
						/>
					</label>
				</div>
			</div>
			<div className={styles.coordinatesContainer}>
				<label>
					Lat:
					<WeaveInput
						type="number"
						step="0.1"
						disabled
						value={latitude?.toPrecision(4) || ''}
					/>
				</label>
				<label>
					Lon:
					<WeaveInput
						type="number"
						step="0.1"
						disabled
						value={longitude?.toPrecision(4) || ''}
					/>
				</label>
				<div className={styles.buttonContainer}>
					<WeaveButton onClick={loadSateliteView}>Load Terrain Texture</WeaveButton>
				</div>
			</div>
		</div>
	)
}